/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SearchAgentDto,
    SearchAgentDtoFromJSON,
    SearchAgentDtoFromJSONTyped,
    SearchAgentDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchAgentsResponse
 */
export interface SearchAgentsResponse {
    /**
     * 
     * @type {Array<SearchAgentDto>}
     * @memberof SearchAgentsResponse
     */
    all: Array<SearchAgentDto>;
    /**
     * 
     * @type {number}
     * @memberof SearchAgentsResponse
     */
    totalCount: number;
}

export function SearchAgentsResponseFromJSON(json: any): SearchAgentsResponse {
    return SearchAgentsResponseFromJSONTyped(json, false);
}

export function SearchAgentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchAgentsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'all': ((json['all'] as Array<any>).map(SearchAgentDtoFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function SearchAgentsResponseToJSON(value?: SearchAgentsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'all': ((value.all as Array<any>).map(SearchAgentDtoToJSON)),
        'totalCount': value.totalCount,
    };
}


